import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { FORWARD } from 'customer-data-filters-ui/filterQueryFormat/rollingDates/RollingDateDirections';
import { LessRolling, GreaterRolling, LessRollingWithOrWithoutYear } from 'customer-data-filters-ui/filterQueryFormat/operator/Operators';
import { InfoIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { InboundDbListSeg, CrmSearch, SalesViews } from '../../filterQueryFormat/strategy/StrategyTypes';
import { useStrategy } from 'customer-data-filters-ui/hooks/useStrategy';
import { hasRemoveTimezoneForDates } from '../../permissions/gates';
import { DATE } from 'customer-data-objects/property/PropertyTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getMessageKeyForOperator = operator => {
  return operator.direction === FORWARD ? 'customerDataFiltersUI.customerDataFilters.DisplayValueRollingInequality.forward' : 'customerDataFiltersUI.customerDataFilters.DisplayValueRollingInequality.backward';
};
const getHelpTextKeyForOperator = (operator, strategyType) => {
  if (strategyType === InboundDbListSeg) {
    if (operator.constructor === LessRolling || operator.constructor === LessRollingWithOrWithoutYear) {
      return operator.direction === FORWARD ? 'customerDataFiltersUI.customerDataFilters.XDayFilterExplanation.InboundDBListSeg.lessForward' : 'customerDataFiltersUI.customerDataFilters.XDayFilterExplanation.InboundDBListSeg.lessBackwards';
    }
    if (operator.constructor === GreaterRolling) {
      return operator.direction === FORWARD ? 'customerDataFiltersUI.customerDataFilters.XDayFilterExplanation.InboundDBListSeg.greaterForward' : 'customerDataFiltersUI.customerDataFilters.XDayFilterExplanation.InboundDBListSeg.greaterBackwards';
    }
  }
  if (strategyType === CrmSearch || strategyType === SalesViews) {
    if (operator.constructor === LessRolling) {
      return operator.direction === FORWARD ? 'customerDataFiltersUI.customerDataFilters.XDayFilterExplanation.CRMSearch.lessForward' : 'customerDataFiltersUI.customerDataFilters.XDayFilterExplanation.CRMSearch.lessBackwards';
    }
    if (operator.constructor === GreaterRolling) {
      return operator.direction === FORWARD ? 'customerDataFiltersUI.customerDataFilters.XDayFilterExplanation.CRMSearch.greaterForward' : 'customerDataFiltersUI.customerDataFilters.XDayFilterExplanation.CRMSearch.greaterBackwards';
    }
  }
  return null;
};
const DisplayValueRollingInequality = ({
  operator,
  getIsUngated
}) => {
  const {
    strategyType
  } = useStrategy();
  if (typeof operator.numberOfDays !== 'number') {
    return null;
  }
  const key = getMessageKeyForOperator(operator);
  const helperTextKey = getHelpTextKeyForOperator(operator, strategyType);
  const zoneInfo = operator.zoneId ? ` (${I18n.moment.tz(undefined, operator.zoneId).format('z')})` : '';
  const showTimeFormat = (() => {
    const {
      hasTimezones
    } = operator;
    if (!hasRemoveTimezoneForDates(getIsUngated) || operator.field && operator.field.type !== DATE || operator.constructor !== LessRolling && operator.constructor !== LessRollingWithOrWithoutYear && operator.constructor !== GreaterRolling) {
      return true;
    }
    return hasTimezones;
  })();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: key,
      options: {
        count: operator.numberOfDays,
        zoneInfo: showTimeFormat ? zoneInfo : ''
      }
    }), helperTextKey && /*#__PURE__*/_jsxs(_Fragment, {
      children: ["\xA0", /*#__PURE__*/_jsx(Tooltip, {
        maxInlineSize: "260px",
        placement: "bottom",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: helperTextKey
        }),
        use: "longform",
        children: /*#__PURE__*/_jsx(InfoIcon, {
          color: "icon-core-subtle"
        })
      })]
    })]
  });
};
export default DisplayValueRollingInequality;